import type { IDropdownOptions } from '@/Interfaces/Data';
import { object, string, date, array } from '@/_config/lib/yup';
import { ENUM_DELIVERYMAN_STATUS } from '@/_constants/enums';

export enum ENUM_CIVIL_STATE {
  SOLTEIRO = 'SOLTEIRO',
  CASADO = 'CASADO',
  DIVORCIADO = 'DIVORCIADO',
  VIUVO = 'VIUVO',
}

export const STATUS_MOTOBOY: IDropdownOptions<
  ENUM_DELIVERYMAN_STATUS,
  ENUM_DELIVERYMAN_STATUS
>[] = [
  {
    key: ENUM_DELIVERYMAN_STATUS.OFFLINE,
    text: 'Offline',
    value: ENUM_DELIVERYMAN_STATUS.OFFLINE,
  },
  {
    key: ENUM_DELIVERYMAN_STATUS.BLOQUEADO,
    text: 'Bloqueado',
    value: ENUM_DELIVERYMAN_STATUS.BLOQUEADO,
  },
  {
    key: ENUM_DELIVERYMAN_STATUS.EM_CORRIDA,
    text: 'Em corrida',
    value: ENUM_DELIVERYMAN_STATUS.EM_CORRIDA,
  },
  {
    key: ENUM_DELIVERYMAN_STATUS.ENTREGA_ASSOCIADA,
    text: 'Entrega associada',
    value: ENUM_DELIVERYMAN_STATUS.ENTREGA_ASSOCIADA,
  },
  {
    key: ENUM_DELIVERYMAN_STATUS.DISPONIVEL,
    text: 'Disponível',
    value: ENUM_DELIVERYMAN_STATUS.DISPONIVEL,
  },
  {
    key: ENUM_DELIVERYMAN_STATUS.REPROVADO,
    text: 'Reprovado',
    value: ENUM_DELIVERYMAN_STATUS.REPROVADO,
  },
  {
    key: ENUM_DELIVERYMAN_STATUS.EXCLUIDO,
    text: 'Excluído',
    value: ENUM_DELIVERYMAN_STATUS.EXCLUIDO,
  },
];

export const MOTOBOYS_FORM_LIST_SCHEMA = object({
  name: string().when([], (schema, name) =>
    name.value ? schema.min(2) : schema.optional(),
  ),
  cellphone: string().optional(),
  deliverymanId: string().objectId().optional(),
  cpf: string().optional(),
  cityId: string().optional(),
  startDate: date().optional().nullable(),
  endDate: date().optional().nullable(),
  status: array(
    string().oneOf(Object.values(ENUM_DELIVERYMAN_STATUS)),
  ).optional(),
  deliveryType: string().optional(),
});

export const GET_MOTOBOYS_LIST = 'GET_MOTOBOYS_LIST';

export const MAX_WIDTH_TABLET = 1080;
export const MIN_WIDTH_TABLET = 768;
